import { useDispatch } from "react-redux";
import { Link, useHistory } from 'react-router-dom';
import { AssetsPng } from "../../assets";
import GoogleLogoutCom from "../../components/common/google/googleLogout";
import { AppConstants, AppRouteUi } from "../../configs";
import {
  ActionAuth,
  StorageAuth,
  useAppSelector,
  VRIAppStateType
} from "../../core";
import { ActionUi } from "../../core/Redux/Slices/sliceUi";
import { useFunctionalityAuth } from "../../pages/hooks";
import { searchInCurrentURL } from "../../utils";
import { useEffect, useRef, useState } from "react";

export function TopNavPublic(): JSX.Element {
  const user = useAppSelector((state: VRIAppStateType) => state.auth.profile);
  const userMenuRef = useRef<HTMLDivElement>(null);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const history = useHistory();
  const dispatch = useDispatch();
  const isLoggedIn = useAppSelector((state: VRIAppStateType) => state.auth.isLoggedIn);
  const { onLogout } = useFunctionalityAuth();
  
  const getLoginPath = (): string => {
    const isMakeSchedule = searchInCurrentURL(AppRouteUi.UserCalendar.Root);
    const isLobby = searchInCurrentURL(AppRouteUi.Lobby.Root);
    const isConsumer = searchInCurrentURL(AppRouteUi.Consumer.Root);
    if (isMakeSchedule || isLobby || isConsumer) {
      return AppRouteUi.Login.ExternalLogin;
    } else {
      return AppRouteUi.Login.Root;
    }
  };

  // const onLogout = React.useCallback(() => {
  //   StorageAuth.Clear();
  //   StorageUserCalendar.Clear();
  //   dispatch(ActionApp.ResetStore());
  // }, [dispatch]);

  useEffect(() => {
    if (StorageAuth.ProfileData?.userRole !== AppConstants.UserRoles.Consumer) {
      StorageAuth.clearStorage();
      dispatch(ActionAuth.resetData());
    }
  }, [dispatch]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
        setIsUserMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <nav className="navbar navbar-expand-lg navbar-light  bg-top-nav sticky-top">
      <div className="nav  nav-item drop-down header-state-info position-relative ms-auto" ref={userMenuRef}>
        <button
          type="button"
          className="nav-link dropdown-toggle "
          id="navbarUserStatusDropdwon"
          aria-haspopup="true"
          aria-expanded={isUserMenuOpen}
          onClick={() => {
            setIsUserMenuOpen((prev) => !prev);
          }}
        >
          <div className="d-flex align-items-center ">
            <div className="me-3 text-white">{user?.name ?? 'Guest User'}</div>
            <div className="header-profile-image d-block">
              <img src={AssetsPng.GenericUser} alt="" className="img-fluid" />
            </div>
          </div>
        </button>
        <div
          className={`dropdown-menu dropdown-menu-right py-0${isUserMenuOpen ? ' show' : ''}`}
          aria-labelledby="navbarDropdown"
        >
          {isLoggedIn ? (
            user?.userRole === AppConstants.UserRoles.Consumer ? (
              <GoogleLogoutCom />
            ) : (
              <Link
                to={AppRouteUi.Login.Root}
                className="dropdown-item  d-lg-block d-xl-block"
                onClick={() => {
                  setIsUserMenuOpen(false);
                  onLogout();
                }}
              >
                Log out
              </Link>
            )
          ) : (
            <Link
              to={getLoginPath()}
              className="dropdown-item d-flex justify-content-center"
              onClick={() => {
                setIsUserMenuOpen(false);
                dispatch(ActionUi.SetPreviousRoute(history.location.pathname));
              }}
            >
              Login
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}
